import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;

  constructor(
      private authService: AuthService,
      private formBuilder: FormBuilder,
      private snackBar: MatSnackBar,
      private router: Router
    ) { 
      this.loginForm = this.formBuilder.group({
        email: '',
        password: ''
      });

  }

  ngOnInit() {
    
  }

  onSubmit(loginData){
    this.authService.login(loginData.email, loginData.password)
    .then(
      (userCredential) => {
        this.loginForm.reset();
        this.router.navigate(['/']);
      }
    )
    .catch(
      (authError) => {
        //TODO: Buscar como se devuelve el error con este tema de los promises
        this.snackBar.open(
          "El correo electronico o la contraseña son incorrectos, intente nuevamente.",
          "Entiendo",
          {duration: 2000}
        );                  
      }
    );
  }

}
